import React from 'react';
import { Box, Text, VStack, HStack, Divider } from '@chakra-ui/react';
import { CIL_POINTS_LABEL, formatCilPoints } from '../../utils/cilPoints';

const PuntiPaymentSummary = ({ saldo, costo }) => {
  const saldoAttuale = Number(saldo) || 0;
  const costoOrdine = Number(costo) || 0;
  const saldoFuturo = saldoAttuale - costoOrdine;
  const sufficiente = saldoFuturo >= 0;

  return (
    <Box
      mt={3}
      p={4}
      bg={sufficiente ? 'purple.50' : 'red.50'}
      borderRadius="md"
      border="1px solid"
      borderColor={sufficiente ? 'purple.200' : 'red.300'}
      w="100%"
    >
      <Text fontSize="sm" fontWeight="semibold" color="purple.800" mb={3}>
        Riepilogo {CIL_POINTS_LABEL}
      </Text>
      <VStack align="stretch" spacing={2}>
        <HStack justify="space-between">
          <Text fontSize="sm" color="gray.600">
            Saldo attuale
          </Text>
          <Text fontSize="sm" fontWeight="semibold">
            {formatCilPoints(saldoAttuale)}
          </Text>
        </HStack>
        <HStack justify="space-between">
          <Text fontSize="sm" color="gray.600">
            Costo ordine
          </Text>
          <Text fontSize="sm" fontWeight="semibold" color="orange.600">
            −{formatCilPoints(costoOrdine)}
          </Text>
        </HStack>
        <Divider borderColor={sufficiente ? 'purple.200' : 'red.200'} />
        <HStack justify="space-between" align="center">
          <Text fontSize="sm" fontWeight="semibold" color="gray.700">
            Saldo dopo il pagamento
          </Text>
          <Text
            fontSize="lg"
            fontWeight="bold"
            color={sufficiente ? 'green.600' : 'red.600'}
          >
            {formatCilPoints(saldoFuturo)}
          </Text>
        </HStack>
      </VStack>
      {!sufficiente && (
        <Text fontSize="xs" color="red.600" mt={3}>
          {CIL_POINTS_LABEL} insufficienti per completare l&apos;iscrizione.
        </Text>
      )}
    </Box>
  );
};

export default PuntiPaymentSummary;
